<div class="flex flex-col justify-between h-full" *transloco="let t">
    <div mat-dialog-content class="flex-grow max-h-full p-0">
        @if (loading()) {
            <div class="absolute left-0 right-0 top-0 bottom-24 z-99 bg-white flex flex-col justify-center mx-auto">
                <p class="mx-auto inline-flex items-center px-4 py-2 font-semibold leading-6 text-sm shadow rounded-md text-white bg-indigo-500 hover:bg-indigo-400 transition ease-in-out duration-150 cursor-not-allowed"
                   disabled="">
                    <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg"
                         fill="none"
                         viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {{ t('pdf-modal.loading') }}
                </p>
            </div>
        }

        @if (loadingError()) {
            <div class="text-center h-full flex flex-col justify-center">
                <mat-icon svgIcon="mat_outline:link_off" class="mx-auto text-secondary"></mat-icon>
                <p>{{ t('pdf-modal.network-error') }}</p>
                <p>{{ t('pdf-modal.try-again') }}</p>
            </div>
        }
        <pdf-viewer
            class="w-full h-full"
            [class.hidden]="loadingError()"
            [src]="data.pdfUrl"
            [render-text]="true"
            (after-load-complete)="onPdfLoaded()"
            (error)="onLoadError()"
            [fit-to-page]="true"
            [original-size]="true"
        ></pdf-viewer>
    </div>
    <div mat-dialog-actions class="mt-4">
        <button mat-button class="ml-auto" (click)="closeModal()">{{ t('generic.close') }}</button>
    </div>
</div>
